import Cookies from 'js-cookie'

/**
 * 设置cookie
 * 
 * @param {String} key cookie名称
 * @param {String} value cookie对应的值
 * @param {Date} expiresDate 过期时间(默认7天过期时间)
 */
export function setCookie(key, value, needPersistence) {
  var expiresDate = new Date();
  //设置一年后过期
  expiresDate.setTime(expiresDate.getTime() + 7 * 24 * 60 * 60 * 1000);
  if(needPersistence){
    Cookies.set(key, value, { expires: expiresDate, path: '/' });
  }else{
    Cookies.set(key, value, { path: '/' });
  }
}


/**
 * 根据指定的key值删除cookie
 * 
 * @param {any} key 
 */
export function deleteCookie(key) {
  Cookies.remove(key);
}

/**
 * 根据key获取指定的cookie value
 * 
 * @param {any} key 
 */
export function getCookie(key) {
  return Cookies.get(key)
}


// WEBPACK FOOTER //
// ./src/util/cookie.util.js